import { TABLE_ROWS_OPTIONS } from "@/ds";
import { hasFinanceiroObrasFilters, isFinanceiroObrasSortField } from "@/modules/financeiro-obras";
import { useFinanceiroObrasListaPagina } from "../../hooks/use-financeiro-obras-lista-pagina";
import {
  FINANCEIRO_LOADING_LABEL,
  FINANCEIRO_NO_VALUE,
  FINANCEIRO_ROWS_PER_PAGE_LABEL,
} from "../../financeiro-obras.constants";
import type {
  FinanceiroObrasListaViewModel,
  FinanceiroObrasListaViewProps,
  FinanceiroObrasSortField,
} from "./types-financeiro-obras-lista-view";
import { useFinanceiroObrasListaViewColunas } from "./use-financeiro-obras-lista-view-colunas";

const ROWS_OPTIONS = [...TABLE_ROWS_OPTIONS];

export function useFinanceiroObrasListaView({
  search,
  filters,
  sort,
  onSort,
  settings,
  isMobile,
  onDetail,
  onClearSearch,
  onClearFilters,
  onResult,
}: FinanceiroObrasListaViewProps): FinanceiroObrasListaViewModel {
  const { items, total, status, errorMessage, reload, first, rows, onPage } =
    useFinanceiroObrasListaPagina({ search, filters, sort, onResult });
  const colunas = useFinanceiroObrasListaViewColunas();
  const hasSearch = search.trim() !== "";
  const hasFilters = hasFinanceiroObrasFilters(filters);

  return {
    ...colunas,
    items,
    total,
    status,
    errorMessage,
    reload,
    first,
    rows,
    rowsOptions: ROWS_OPTIONS,
    onPage,
    sort,
    onSort,
    isSortField: (campo: unknown): campo is FinanceiroObrasSortField =>
      isFinanceiroObrasSortField(campo),
    settings,
    isMobile,
    semValor: FINANCEIRO_NO_VALUE,
    onDetail,
    loadingLabel: FINANCEIRO_LOADING_LABEL,
    rowsPerPageLabel: FINANCEIRO_ROWS_PER_PAGE_LABEL,
    ariaLabel: "Obras do Financeiro",
    testId: "financeiro-obras",
    variant: "financeiro",
    hasSearch,
    hasFilters,
    onClear: hasSearch ? onClearSearch : hasFilters ? onClearFilters : undefined,
  };
}
